/**
 * Config for ModalInformationDataConfig
 * @param {*} [_this] parameter optional for pass context and can run function of the context.
 * @return {*}  ModalInformationDataConfig
 */
export const ModalInstructionsDataConfig = (_this?, remoteData?) => {
  return {
    /* icon : remoteData.icon ? remoteData.icon : 'https://firebasestorage.googleapis.com/v0/b/gnx-mvp-improved-stg.appspot.com/o/Default%2FPublic%20Services%2Falerts%2Ftrans_off.svg?alt=media&token=93fef758-dcff-4d1a-8292-2bcbdadf30d2', */
    title: remoteData?.title
      ? remoteData.title
      : 'Sigue estos pasos para pagar con tus coins.',
    /* subtitle : remoteData.subtitle ? remoteData.subtitle : 'Puedes realizar pago de servicios de forma automática, solo debes ingresar el cédula del cliente y el valor del servicio.', */
    hasButtonDismiss: remoteData?.hasButtonDismiss
      ? remoteData.hasButtonDismiss
      : true,
    labelButtonDismiss: remoteData?.labelButtonDismiss
      ? remoteData.labelButtonDismiss
      : 'Regresar',
    information: remoteData?.information
      ? remoteData.information
      : [
          {
            img: 'https://firebasestorage.googleapis.com/v0/b/gnx-kcp-estrellas-kimberly-prd.appspot.com/o/Pagos%2FGroup%209553.svg?alt=media&token=ec2f75a8-83a8-41ac-8781-9f19c7225ce5',
            message: 'Ten a mano tu factura',
          },
          {
            img: 'https://firebasestorage.googleapis.com/v0/b/gnx-kcp-estrellas-kimberly-prd.appspot.com/o/Pagos%2FGroup%209555.svg?alt=media&token=9012598e-ba1d-45f1-aa60-66a2aeb26878',
            message: 'Selecciona el servicio a pagar',
          },
          {
            img: 'https://firebasestorage.googleapis.com/v0/b/gnx-kcp-estrellas-kimberly-prd.appspot.com/o/Pagos%2FComponent%209%20%E2%80%93%201.svg?alt=media&token=9ec79384-23b0-451c-8f28-47e5adcc5177',
            message: 'Ingresa la referencia de pago',
          },
          {
            img: 'https://firebasestorage.googleapis.com/v0/b/gnx-kcp-estrellas-kimberly-prd.appspot.com/o/Pagos%2Fcheckmark-done-circle-outline.svg?alt=media&token=758398cf-2217-4a94-a033-bfa1703084a5',
            message: 'Aprueba la redención',
          },
        ],
    buttons: remoteData?.buttons
      ? remoteData.buttons
      : [
          //    { label: 'Regresar', color: 'primary', handler: () => { _this.dismiss() } }
        ],
  };
};
